// @ts-nocheck - Legacy file with type issues requiring refactoring (TODO: GXM-XXXX)
import React, { useEffect, useRef, useState } from "react";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import API_ROUTES from "../../api-routes";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Skeleton } from "primereact/skeleton";
import { format } from "date-fns";
import { currencyList } from "~/utils/currency";
import icon from "../../assets/images/director-empty-icon.png";
import AuditSidebar from "~/components/audit-sidebar/AuditSidebar";
import AdminOnly from "~/components/AdminOnly";
import EmptyDataView from "./EmptyDataView";
import CustomeButton from "~/components/Button";
import { Menu } from "primereact/menu";
import { useLocation } from "react-router-dom";
import { Toast } from "primereact/toast";
import ToastMessage from "~/components/ToastMessage";
import API_ROUTES_V2 from "~/api-routes-v2";
import apiService from "~/services/service";

const ShareHolderTab = ({
  onAddShareholderClick,
  shareLoading,
  shareholderArr,
  refetchShareholders,
}: {
  onAddShareholderClick: () => void;
  shareLoading: boolean;
  shareholderArr: Array<Record<string, unknown>>;
  refetchShareholders: () => Promise<void>;
}) => {
  const { id: entityId } = useParams();
  const [isAuditSidebarOpen, setIsAuditSidebarOpen] = useState(false);
  const [selectedShareHolder, setSelectedShareHolder] = useState(null);
  const [sortedData, setSortedData] = useState([]);
  const [sortMeta, setSortMeta] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const contextMenuRef = useRef({});
  const navigate = useNavigate();
  const getFullName = (shareholder) =>
    [shareholder?.name, shareholder?.other_name, shareholder?.last_name]
      ?.filter(Boolean)
      .join(" ")
      .trim()
      .toLowerCase() ||
    shareholder?.legal_name?.toLowerCase() ||
    "";

  const filteredData = (shareholderArr || []).filter((row) => {
    const fullName = getFullName(row);
    const type = row?.type?.toLowerCase() || "";
    const search = searchTerm.toLowerCase();

    return fullName.includes(search) || type.includes(search);
  });

  const auditLabels = () => {
    return {
      create: "Shareholder Created",
      update: "Shareholder Updated",
      delete: "Shareholder Deleted",
    };
  };
  const handleEditClick = (rowData) => {
    navigate(`/entity/${entityId}/share-holders/${rowData.id}/info`);
  };
  const location = useLocation();
  const toast = useRef<Toast>(null);
  const deletedShareholderRef = useRef<{
    shareholderId: string;
    shareholderName: string;
  } | null>(null);

  const restoreShareholder = async (id: string) => {
    return await apiService(API_ROUTES_V2.RESTORE_SHAREHOLDER, "POST", {
      replace: { id, entity_id: entityId },
    });
  };

  useEffect(() => {
    if (location.state?.showDeleteToast) {
      const { shareholderId, shareholderName } = location.state;

      if (!shareholderId || !shareholderName) {
        return;
      }

      deletedShareholderRef.current = {
        shareholderId,
        shareholderName,
      };

      toast.current?.show({
        severity: "error",
        summary: "Profile Deleted.",
        detail: `The Shareholder's profile "${shareholderName}" was deleted.`,
        icon: "pi pi-trash",
        otherAction: "Undo ?",
        handleOtherAction: async () => {
          const currentRef = deletedShareholderRef.current;
          if (!currentRef?.shareholderId) {
            toast.current?.show({
              severity: "error",
              summary: "Undo Failed",
              detail: "Shareholder ID is missing",
            });
            return;
          }

          try {
            await restoreShareholder(currentRef.shareholderId);
            toast.current?.clear();
            toast.current?.show({
              severity: "success",
              summary: "Profile Restored.",
              detail: `The Shareholder's profile "${currentRef.shareholderName}" was restored.`,
            });
            await refetchShareholders();
          } catch (e) {
            toast.current?.clear();
            toast.current?.show({
              severity: "error",
              summary: "Undo Failed",
              detail: "Unable to restore shareholder",
            });
          }
        },
      });

      navigate(location.pathname + location.search, {
        replace: true,
        state: {},
      });
    }
  }, [location.state, navigate, location.pathname, location.search]);

  useEffect(() => {
    if (selectedShareHolder) {
      const id = selectedShareHolder.id;
      navigate(`/entity/${entityId}/share-holders/${id}/info`, {
        state: {
          rowData: selectedShareHolder,
        },
      });
    }
  }, [selectedShareHolder, navigate, entityId]);
  const statusColorClass = {
    Active: "active-circle-fill",
    Inactive: "inactive-circle-fill",
    Deceased: "deceased-circle-fill",
  };

  const statusOptionsTemplate = (status) => {
    return (
      <div className="flex align-items-center gap-2">
        <span
          className={`pi pi-circle-fill ${statusColorClass[status]}`}
        ></span>
        <span>{status}</span>
      </div>
    );
  };

  const handleSort = (event) => {
    const multiSortMeta = event.multiSortMeta || [];
    const dataToSort = [...filteredData];

    dataToSort.sort((firstRow, secondRow) => {
      for (const sortMeta of multiSortMeta) {
        const { field, order } = sortMeta;

        const firstValue =
          field === "shareholder_name"
            ? getFullName(firstRow)
            : (firstRow[field] ?? "");

        const secondValue =
          field === "shareholder_name"
            ? getFullName(secondRow)
            : (secondRow[field] ?? "");

        const comparisonResult =
          firstValue.toString().localeCompare(secondValue.toString()) * order;

        if (comparisonResult !== 0) {
          return comparisonResult;
        }
      }

      return 0;
    });

    setSortedData(dataToSort);
    setSortMeta(multiSortMeta);
  };

  useEffect(() => {
    setSortedData([...filteredData]);
  }, [shareholderArr, searchTerm]);

  return (
    <>
      <div className="flex align-items-center">
        <div className="flex-1">
          <div className="input-wrapper-container search__shareholder mb-4">
            <span className="pi pi-search"></span>
            <input
              type="text"
              placeholder="Search shareholders by given name, surname or shareholder type"
              className="appearance-none outline-none w-full"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <span className="pi pi-search"></span>
          </div>
        </div>
        <AdminOnly>
          <div className="field mb-0">
            <div className="flex justify-content-end">
              <button
                className="add-new-contact mb-4"
                onClick={onAddShareholderClick}
              >
                Add Shareholder <span className="pi pi-plus ml-2"></span>
              </button>
            </div>
          </div>
        </AdminOnly>
      </div>
      <Card className="gen-card">
        <div className="formgrid grid">
          <div className="field col-12 table-section">
            <div className="card">
              {shareholderArr.length > 0 ? (
                <DataTable
                  value={sortedData}
                  sortMode="multiple"
                  tableStyle={{ minWidth: "100rem" }}
                  paginator={sortedData?.length > 10}
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  rows={10}
                  rowsPerPageOptions={[10, 20, 30]}
                  className="datatable-right-align"
                  emptyMessage="No results were found"
                  onSort={handleSort}
                  multiSortMeta={sortMeta}
                >
                  <Column
                    header="Shareholder"
                    sortable
                    className="table-col-width"
                    sortField="shareholder_name"
                    body={(rowData) => (
                      <Link
                        className="officer__link"
                        to={`/entity/${entityId}/share-holders/${rowData?.id}/info`}
                      >
                        {[
                          rowData?.name,
                          rowData?.other_name,
                          rowData?.last_name,
                        ]
                          .filter(Boolean)
                          .join(" ") || rowData?.legal_name}
                      </Link>
                    )}
                  />
                  <Column field="type" header="Type" sortable />
                  <Column
                    header="Total Number of Shares"
                    body={(f) => f?.totalShares}
                  />
                  <Column
                    header="Share Value"
                    body={(f) => {
                      const currency = currencyList.find(
                        (c) => c.value === f?.currency,
                      );
                      return (
                        <span>
                          {currency?.symbol} {f?.share_value}
                        </span>
                      );
                    }}
                  />
                  <Column
                    header="Share %"
                    body={(f) => `${f?.share_percentage}%`}
                  />
                  <Column
                    header="Share Classes"
                    body={(f) => f?.share_classes?.join(",")}
                  />
                  <Column
                    header="Last Update"
                    body={(f) =>
                      f.lastUpdateDate &&
                      format(f.lastUpdateDate, "MMMM do, yyyy")
                    }
                  />
                  <Column
                    header="Status"
                    body={(f) =>
                      f?.status ? statusOptionsTemplate(f?.status) : null
                    }
                  />
                  <Column
                    body={(rowData) => (
                      <AdminOnly>
                        <div className="flex flex-row-reverse">
                          <span
                            className="pi pi-pencil ml-4 mr-3 pencil-pointer"
                            onClick={() => handleEditClick(rowData)}
                          ></span>
                        </div>
                      </AdminOnly>
                    )}
                  />
                </DataTable>
              ) : !shareLoading ? (
                <EmptyDataView
                  Icon={
                    <img
                      className="users-card-icon-img"
                      src={icon}
                      alt="Users Icon"
                    />
                  }
                  Header="Looks like there aren't any shareholders appointed yet!"
                  Description="Let's start by adding your first one!"
                  handleNavigate={onAddShareholderClick}
                  label={"Add Shareholder"}
                />
              ) : (
                /* ✅ SKELETON */
                <DataTable
                  value={Array(5).fill({})}
                  tableStyle={{ minWidth: "100%" }}
                  className="datatable-right-align"
                  paginator
                  rows={10}
                  rowsPerPageOptions={[10, 20, 30]}
                >
                  <Column header="Shareholder" body={<Skeleton />} />
                  <Column header="Type" body={<Skeleton />} />
                  <Column header="Total Number of Shares" body={<Skeleton />} />
                  <Column header="Share Value" body={<Skeleton />} />
                  <Column header="Share %" body={<Skeleton />} />
                  <Column header="Share Classes" body={<Skeleton />} />
                  <Column header="Last Update" body={<Skeleton />} />
                  <Column header="Status" body={<Skeleton />} />
                </DataTable>
              )}
            </div>
          </div>
        </div>
      </Card>
      {isAuditSidebarOpen && (
        <AuditSidebar
          heading="Shareholders"
          endpoint={API_ROUTES.FETCH_SHAREHOLDERS_AUDIT}
          id={entityId}
          objectType="entity"
          endType="SHAREHOLDERS"
          setSidebarToggle={setIsAuditSidebarOpen}
          sidebarToggle={isAuditSidebarOpen}
          labels={auditLabels}
        />
      )}
      <ToastMessage ref={toast} position="bottom-right" />
    </>
  );
};

export default ShareHolderTab;
